import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Card, Button, Form, Tabs, Tab, InputGroup, Spinner } from "react-bootstrap";
import { fetchDataRead } from "../../Utility";
import { MdAdd, MdDelete, MdEdit, MdClose } from "react-icons/md";


function EmployeeAdd() {
    const routeLocation = useLocation();

    const userData = sessionStorage.getItem("user");
    const userObj = userData ? JSON.parse(userData) : {};
    const COLLAPSE_EMPLOYER_TO_DEDUCTIONS = true;
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "School Admin"];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());
    const [profileFile, setProfileFile] = React.useState(null);
    const [profilePreview, setProfilePreview] = React.useState(null);
    const [photoPreviewUrl, setPhotoPreviewUrl] = React.useState(null);

    const onPhotoPick = (e) => {
        const f = e.target.files?.[0] || null;
        setProfileFile(f);
        if (f) setProfilePreview(URL.createObjectURL(f));
        else setProfilePreview(null);
    };
    const [activeKey, setActiveKey] = useState("basic");
    const [editingCompId, setEditingCompId] = useState(null);

    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [shifts, setShifts] = useState([]);
    const [managers, setManagers] = useState([]);
    const [banks, setBanks] = useState([]);
    const [employeeTypes, setEmployeeTypes] = useState([]);
    const [roles, setRoles] = useState([]);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [editEmpId, setEditEmpId] = useState(null);

    const tabsOrder = ["basic", "education", "experience", "parentdetails", "bank", "salary"];
    const parentRef = useRef(null);
    ;
    const currentIndex = tabsOrder.indexOf(activeKey);
    const isFirst = currentIndex === 0;
    const isLast = currentIndex === tabsOrder.length - 1;

    const [salaryComponents, setSalaryComponents] = useState([]);
    const [salaryBreakup, setSalaryBreakup] = useState([]);
    const [selectedSalaryComp, setSelectedSalaryComp] = useState({ component_id: "", amount: "" });

    const basicRef = useRef(null);
    const educationRef = useRef(null);
    const experienceRef = useRef(null);
    const bankRef = useRef(null);
    const salaryRef = useRef(null);

    const [form, setForm] = useState({
        emp_id: "",
        firstname: "",
        surname: "",
        phonenumber: "",
        email: "",
        address: "",
        roleid: "",
        emp_code: "",
        city: "",
        state: "",
        country: "",
        gender: "",
        password: "",
        UAN: "",
        Aadhar: "",
        PF_No: "",
        esi_opted: "N",  // This is correct for React state
        esi_number: "",
        dob: "",
        doj: "",
        dor: "",
        designation_id: "",
        is_married: "",
        deptid: "",
        employee_type_id: "",
        shift_id: "",
        Reporting_To: "",
        school_id: userObj.school_id,
        cash_bank_type_id: "",
        account_number: "",
        ifsc_code: "",
        account_name: "",
        bank_name: "",
        branch_name: "",
        location: "",
        createdby: userObj.userid || "",
        createddate: "",
        lastmodifiedby: userObj.userid || "",
        lastmodifieddate: "",
        experiences: [],
        educations: [],
        employee_salary_id: "",
        ctc: "",
        gross_salary: "",
        net_salary: "",
        effective_from: "",
        effective_to: "",
        is_current: "Y",
        revision_reason: "",
        father_name: "",
        father_phone: "",
        father_email: "",
        father_occupation: "",

        mother_name: "",
        mother_phone: "",
        mother_email: "",
        mother_occupation: "",
        spouse_name: "",
        spouse_phone: "",
        spouse_email: "",
        spouse_occupation: "",
        // esi_opted: "N",
        // esi_number: "",
        grace_time: "",

        children: [],
    });
    const todayLocal = new Date().toLocaleDateString('en-CA'); // e.g., 2025-09-18

    const getCurrentContainer = useCallback(() => {
        const map = { basic: basicRef, education: educationRef, experience: experienceRef, parentdetails: parentRef, bank: bankRef, salary: salaryRef };
        return map[activeKey]?.current || null;
    }, [activeKey]);
    const addChild = () => {
        setForm(prev => ({
            ...prev,
            children: [
                ...(prev.children || []),
                { child_name: "", child_dob: "", child_gender: "" },
            ],
        }));
    };

    const fetchCutOffTime = async () => {
        try {
            const response = await axios.get(baseUrl + "/getcutofftime/", {
                params: { school_id: userObj.school_id }
            });

            const cutOffValue = response.data.cut_off_time;

           
            setForm((prev) => ({
                ...prev,
                grace_time: cutOffValue   
            }));

        } catch (error) {
            console.log("Error fetching cut-off time:", error);
        }
    };



    useEffect(() => {
        fetchCutOffTime();
    }, []);


    const removeChild = (index) => {
        setForm(prev => ({
            ...prev,
            children: (prev.children || []).filter((_, i) => i !== index),
        }));
    };

    const handleChildChange = (index, key, value) => {
        setForm(prev => {
            const list = [...(prev.children || [])];
            list[index] = { ...(list[index] || {}), [key]: value };
            return { ...prev, children: list };
        });
    };

    const showFirstInvalidIn = useCallback((container) => {
        if (!container) return false;
        const requiredEls = Array.from(container.querySelectorAll("[required]"));
        const seenRadioNames = new Set();
        const scrollToCenter = (el) => {
            el?.scrollIntoView({ behavior: "smooth", block: "center" });
            el?.focus?.();
            el?.reportValidity?.();
        };
        for (const el of requiredEls) {
            if (el.type === "radio") {
                const name = el.name;
                if (seenRadioNames.has(name)) continue;
                seenRadioNames.add(name);
                const group = container.querySelectorAll(`input[type="radio"][name="${name}"]`);
                const anyChecked = Array.from(group).some((r) => r.checked);
                if (!anyChecked) {
                    scrollToCenter(group[0]);
                    return true;
                }
                continue;
            }
            if (!el.checkValidity()) {
                scrollToCenter(el);
                return true;
            }
        }
        return false;
    }, []);

    const goNext = () => {
        const order = ["basic", "education", "experience", "parentdetails", "bank", "salary"];
        const i = order.indexOf(activeKey);
        if (i === -1 || i === order.length - 1) return;

        const container = getCurrentContainer();
        if (blockIfInvalid(container)) return;
        setActiveKey(order[i + 1]);
    };

    const goPrev = () => {
        const order = ["basic", "education", "experience", "parentdetails", "bank", "salary"];
        const i = order.indexOf(activeKey);
        if (i <= 0) return;
        setActiveKey(order[i - 1]);
    };

    const goNextValidated = () => {
        if (isLast) return;
        const container = getCurrentContainer();
        if (showFirstInvalidIn(container)) return;
        setActiveKey(tabsOrder[currentIndex + 1]);
    };

    // -------------------- Helpers --------------------
    // Build preview URL from DB path like "uploads/5_hafeezpet/u8_20250924101856.png"
    const buildEmployeeImageUrl = (apiRoot, profilePath) => {
        if (!apiRoot || !profilePath) return null;
        const root = String(apiRoot).replace(/\/$/, "");
        const stripped = String(profilePath).replace(/^\/?uploads\//, ""); // remove leading "uploads/"
        return `${root}/uploads/get-image/${encodeURIComponent(stripped)}`;
    };

    const toYmd = (d) => (d ? String(d).slice(0, 10) : "");
    const apiGenderToUi = (g) => (g === "M" ? "Male" : g === "F" ? "Female" : g ? "Other" : "");

    function mapApiToForm(api, userObj) {
        const b = api?.basic || {};
        const p = api?.parents || {};                 // new: parents block
        const bank = (api?.bank_details || [])[0] || {};
        const salList = api?.salary_details || api?.salary || [];
        const currentSal = salList.find((s) => s.is_current === "Y") || salList[0] || {};

        const toYmd = (d) => (d ? String(d).slice(0, 10) : "");
        const apiGenderToUi = (g) => (g === "M" ? "Male" : g === "F" ? "Female" : g ? "Other" : "");

        return {
            // ===== Basic =====
            emp_id: b.emp_id ?? "",
            firstname: b.firstname ?? "",
            surname: b.surname ?? "",
            phonenumber: b.phonenumber ?? "",
            email: b.email ?? "",
            emp_code: b.emp_code ?? "",
            address: b.address ?? "",
            roleid: b.roleid ?? "",
            city: b.city ?? "",
            state: b.state_id ?? "",
            country: b.country_id ?? "",
            gender: apiGenderToUi(b.gender),
            UAN: b.uan ?? "",
            Aadhar: b.aadhar ?? "",
            PF_No: b.pf_no ?? "",
            esi_opted: b.opted_for_esi ?? "N",
            esi_number: b.esi_number ?? "",
            dob: toYmd(b.dob),
            doj: toYmd(b.doj),
            dor: toYmd(b.dor),
            designation_id: b.designation_id ?? "",
            // prefer parents.is_married if present, else basic
            is_married: (p.is_married ?? b.is_married ?? ""),
            grace_time: b.grace_time ?? 0,
            deptid: b.dept_id ?? "",
            employee_type_id: b.employee_type_id ?? "",
            shift_id: b.shift_id ?? "",
            Reporting_To: b.reporting_to ?? "",
            school_id: b.school_id ?? userObj?.school_id ?? 0,
            profile_photo: b.profile_photo ?? "",
            cash_bank_type_id: b.cash_bank_type_id ?? "",

            // Auth/meta
            password: "",
            createdby: userObj?.userid || userObj?.user_id || "",
            lastmodifiedby: userObj?.userid || userObj?.user_id || "",

            // ===== Family (Parents) =====
            father_name: p.father_name ?? b.father_name ?? "",
            father_phone: p.father_phone ?? b.father_phone ?? "",
            father_email: p.father_email ?? b.father_email ?? "",
            father_occupation: p.father_occupation ?? b.father_occupation ?? "",

            mother_name: p.mother_name ?? b.mother_name ?? "",
            mother_phone: p.mother_phone ?? b.mother_phone ?? "",
            mother_email: p.mother_email ?? b.mother_email ?? "",
            mother_occupation: p.mother_occupation ?? b.mother_occupation ?? "",

            spouse_name: p.spouse_name ?? b.spouse_name ?? "",
            spouse_phone: p.spouse_phone ?? b.spouse_phone ?? "",
            spouse_email: p.spouse_email ?? b.spouse_email ?? "",
            spouse_occupation: p.spouse_occupation ?? b.spouse_occupation ?? "",

            // ===== Children =====
            children: Array.isArray(api?.children)
                ? api.children.map((ch) => ({
                    child_id: ch.child_id ?? null,
                    child_name: ch.child_name ?? "",
                    child_dob: toYmd(ch.child_dob),
                    child_gender: ch.child_gender ?? "",
                }))
                : [],

            // ===== Bank (keep ID!) =====
            emp_bank_details_id: bank.emp_bank_details_id ?? null,
            account_number: bank.account_number ?? "",
            ifsc_code: bank.ifsc_code ?? "",
            account_name: bank.account_name ?? "",
            bank_name: bank.bank_name ?? "",
            branch_name: bank.branch_name ?? "",
            location: bank.location ?? "",

            // ===== Salary header (keep ID!) =====
            employee_salary_id: currentSal?.employee_salary_id ?? "",
            ctc: currentSal?.ctc ?? "",
            gross_salary: currentSal?.gross_salary ?? "",
            net_salary: currentSal?.net_salary ?? "",
            effective_from: toYmd(currentSal?.effective_from),
            effective_to: toYmd(currentSal?.effective_to),
            is_current: currentSal?.is_current ?? "Y",
            revision_reason: currentSal?.revision_reason ?? "",

            // (Optional) expose raw components if your UI needs them
            salary_components: Array.isArray(currentSal?.components)
                ? currentSal.components.map((c) => ({
                    employee_salary_component_id: c.employee_salary_component_id ?? null,
                    salary_component_id: c.salary_component_id ?? null,
                    component_name: c.component_name ?? "",
                    component_type_id: c.component_type_id ?? null,
                    component_type_name: c.component_type_name ?? "",
                    component_amount: c.component_amount ?? 0,
                }))
                : [],

            // ===== Educations (keep ID!) =====
            educations: (api?.education_details || []).map((e) => ({
                emp_education_id: e.emp_education_id ?? null,
                degree_name: e.degree_name ?? "",
                field_of_study: e.field_of_study ?? "",
                institution_name: e.institution_name ?? "",
                board_university: e.board_university ?? "",
                graduation_year: e.graduation_year ?? "",
                percentage: e.percentage ?? "",
                cgpa: e.cgpa ?? "",
                certificate_path: e.certificate_path ?? ""
            })),

            // ===== Experiences (keep ID!) =====
            experiences: (api?.experience_details || []).map((x) => ({
                emp_experience_id: x.emp_experience_id ?? null,
                company_name: x.organization_name ?? "",
                designation: x.designation ?? x.designation_name ?? "",
                location: x.location ?? "",
                start_date: toYmd(x.start_date),
                end_date: toYmd(x.end_date),
                years_of_experience: x.years_of_experience ?? "",
                previous_drawn: x.previous_drawn ?? "",
                exp_certificate_path: x.exp_certificate_path ?? "",
                certificate_file: null, // For new file uploads
                certificate_uploading: false,
                certificate_upload_error: null
            })),
        };
    }

    // Normalise component type from various shapes/labels
    const normalizeType = (typeLike, is_deduction) => {
        const T = String(typeLike || "").trim().toUpperCase();
        // EMPLOYER → DEDUCTION when the toggle is on
        if (T.includes("EMPLOYER")) {
            return COLLAPSE_EMPLOYER_TO_DEDUCTIONS ? "DEDUCTION" : "EMPLOYER";
        }
        if (T === "DEDUCTION" || String(is_deduction || "").toUpperCase() === "Y") return "DEDUCTION";
        return "EARNING";
    };



    // Build lookup from master salary components
    const compIndex = useMemo(() => {
        const idx = {};
        (salaryComponents || []).forEach(c => {
            const id = Number(c.salary_component_id ?? c.component_id ?? c.id);
            if (!id) return;
            const name =
                c.component_name ??
                c.salary_component_name ??
                c.name ??
                c.component_code ??
                "Component";

            const normType = normalizeType(c.component_type_name ?? c.component_type, c.is_deduction);

            idx[id] = {
                name,
                type: normType,                        // "EARNING" | "DEDUCTION" | "EMPLOYER"
                isDeduction: normType === "DEDUCTION",
                isEmployer: normType === "EMPLOYER",
            };
        });
        return idx;
    }, [salaryComponents]);


    const metaFor = (compId) => compIndex[Number(compId)] || { name: "Component", type: "EARNING", isDeduction: false };

    const isDeductionFor = (item) => {
        if (String(item.is_deduction || "").toUpperCase() === "Y") return true;
        const t = String(item.component_type || item.component_type_name || "").toUpperCase();
        if (t) return t === "DEDUCTION";
        return metaFor(item.salary_component_id).isDeduction;
    };
    const typeFor = (item) => {
        // Prefer row’s own type fields first
        const direct = normalizeType(item.component_type_name ?? item.component_type, item.is_deduction);
        if (direct !== "EARNING") return direct;
        // Fall back to master
        const meta = compIndex[Number(item.salary_component_id)] || {};
        return meta.type || "EARNING";
    };


    const totals = useMemo(() => {
        return (salaryBreakup || []).reduce(
            (acc, it) => {
                const t = typeFor(it); // EMPLOYER already mapped to DEDUCTION if toggle is true
                const v = Number(it.amount || 0);
                if (t === "DEDUCTION") acc.deductions += v;
                else acc.earnings += v;
                return acc;
            },
            { earnings: 0, deductions: 0 }
        );
    }, [salaryBreakup, compIndex]);

    useEffect(() => {
        const gross = Number(totals.earnings || 0);
        const net = gross - Number(totals.deductions || 0);
        const ctc = gross; // since employer is merged into deductions, don't add it to CTC
        setForm(p => ({
            ...p,
            gross_salary: gross || "",
            ctc: ctc || "",
            net_salary: net || ""
        }));
    }, [totals.earnings, totals.deductions]);



    const fetchDESIGNAT = async () => {
        try {
            const response = await axios.post(baseUrl + "/designation/", {
                action: "READ", school_id: userObj.school_id
            });
            setDesignations(response.data);
        } catch (error) {
            console.error("Error fetching students:", error);
        }
    };
    // -------------------- API reads --------------------
    // master data
    useEffect(() => {
        fetchDataRead("/department/", setDepartments, userObj.school_id);

        fetchDataRead("/shiftread/", setShifts, userObj.school_id);
        fetchDataRead("/role/", setRoles, userObj.school_id);
        fetchDataRead("/states/", setStates, userObj.school_id);
        fetchDataRead("/country/", setCountries, userObj.school_id);
        fetchDataRead("/employees/", setManagers, userObj.school_id);
    }, []); // eslint-disable-line
    useEffect(() => {
        fetchDESIGNAT();
    }, []); // es
    useEffect(() => {
        axios
            .post(`${baseUrl}/salarycomponent/`, { action: "READ", school_id: userObj.school_id })
            .then((res) => setSalaryComponents(res.data || []))
            .catch(() => toast.error("Failed to load salary components"));
    }, [baseUrl, userObj.school_id]);

    useEffect(() => {
        axios
            .get(`${baseUrl}/employee-type/`)
            .then((res) => setEmployeeTypes(res.data || []))
            .catch(() => toast.error("Failed to load employee types"));
    }, [baseUrl]);

    useEffect(() => {
        axios
            .get(`${baseUrl}/cashbank-type/`)
            .then((res) => setBanks(res.data || []))
            .catch(() => toast.error("Failed to load cash/bank types"));
    }, [baseUrl]);

    // single read of the employee
    const empIdFromRoute = routeLocation.state?.emp_id || routeLocation.state?.empData?.emp_id;
    useEffect(() => {
        if (!empIdFromRoute) return;

        setEditEmpId(empIdFromRoute);

        axios
            .get(`${baseUrl}/full-details/${empIdFromRoute}`)
            .then(({ data }) => {
                const mapped = mapApiToForm(data, userObj);
                setForm((prev) => ({ ...prev, ...mapped }));
                setActiveKey("basic");
                hydrateSalaryFromApi(data, mapped);
            })
            .catch((err) => {
                toast.error("Failed to load employee details");
                console.error(err);
            });
    }, [empIdFromRoute, baseUrl]); // eslint-disable-line

    // Fill salaryBreakup from nested salary -> components or legacy keys
    const hydrateSalaryFromApi = (api, mappedForm) => {
        const salList = api?.salary || api?.salary_details || [];
        const currentSal =
            salList.find((s) => String(s.is_current || "").toUpperCase() === "Y") || salList[0];

        // Prefer nested components
        if (currentSal && Array.isArray(currentSal.components) && currentSal.components.length) {
            const rows = currentSal.components.map((c) => ({
                employee_salary_component_id: c.employee_salary_component_id ?? null,
                employee_salary_id: currentSal.employee_salary_id ?? null,
                salary_component_id: Number(c.salary_component_id ?? c.component_id ?? c.id),
                amount: Number(c.component_amount ?? c.amount ?? 0),

                component_name: c.component_name ?? c.salary_component_name ?? c.name ?? "",
                component_type: String(c.component_type_name || c.component_type || "").toUpperCase(),
                is_deduction:
                    String(c.component_type_name || c.component_type || "").toUpperCase() === "DEDUCTION" ? "Y" : "N",

                is_current: currentSal.is_current || "Y",
            }));

            setSalaryBreakup(rows);

            // Ensure salary header fields are filled if missing
            if (!mappedForm?.employee_salary_id) {
                setForm((p) => ({
                    ...p,
                    employee_salary_id: currentSal.employee_salary_id ?? "",
                    effective_from: toYmd(currentSal.effective_from),
                    effective_to: toYmd(currentSal.effective_to),
                    is_current: currentSal.is_current || "Y",
                    ctc: currentSal.ctc ?? "",
                    gross_salary: currentSal.gross_salary ?? "",
                }));
            }
            return;
        }

        // Legacy fallback only if arrays exist and have rows
        const legacy =
            (Array.isArray(api?.salary_breakup) && api.salary_breakup.length ? api.salary_breakup : null) ||
            (Array.isArray(api?.salary_components) && api.salary_components.length ? api.salary_components : null);

        if (legacy) {
            setSalaryBreakup(
                legacy.map((it) => ({
                    employee_salary_component_id: Number(it.employee_salary_component_id ?? it.emp_salary_component_id) || null,
                    employee_salary_id: Number(it.employee_salary_id ?? it.emp_salary_id ?? it.salary_id) || null,
                    salary_component_id: Number(it.salary_component_id ?? it.component_id ?? it.id) || 0,
                    amount: Number(it.component_amt ?? it.amount ?? 0) || 0,
                    component_type: String(it.component_type || it.component_type_name || "").toUpperCase(),
                    is_deduction:
                        String(
                            it.is_deduction ??
                            (String(it.component_type || it.component_type_name || "").toUpperCase() === "DEDUCTION" ? "Y" : "N")
                        ).toUpperCase() === "Y"
                            ? "Y"
                            : "N",
                    is_current: (it.is_current ?? mappedForm?.is_current ?? "Y"),
                }))
            );
        } else {
            setSalaryBreakup([]);
        }
    };

    // -------------------- UI handlers --------------------
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
    };
    const handleAadhar = (e) => {
        const { value } = e.target;
        if (/^\d{0,12}$/.test(value)) setForm((p) => ({ ...p, Aadhar: value }));
    };
    const digitsOnly = (key) => (e) => {
        const { value } = e.target;
        if (/^\d*$/.test(value)) setForm((p) => ({ ...p, [key]: value }));
    };
    const handleIFSC = (e) => {
        const { value } = e.target;
        if (/^[A-Za-z0-9]{0,11}$/.test(value)) setForm((p) => ({ ...p, ifsc_code: value.toUpperCase() }));
    };
    const handleRadioChange = (e) => setForm((prevForm) => ({ ...prevForm, gender: e.target.value }));

    const addEducation = () => {
        setForm((prev) => ({
            ...prev,
            educations: [
                ...(prev.educations || []),
                {
                    degree_name: "",
                    field_of_study: "",
                    institution_name: "",
                    board_university: "",
                    graduation_year: "",
                    percentage: "",
                    cgpa: "",
                    certificate_path: null,
                    certificate_file: null,
                },
            ],
        }));
    };
    const removeEducation = (index) => {
        setForm((prev) => ({ ...prev, educations: (prev.educations || []).filter((_, i) => i !== index) }));
    };
    const handleEduChange = (index, key, value) => {
        setForm((prev) => {
            const list = [...(prev.educations || [])];
            const row = { ...(list[index] || {}) };
            row[key] = value;
            list[index] = row;
            return { ...prev, educations: list };
        });
    };

    const addExperience = () => {
        setForm((prev) => ({
            ...prev,
            experiences: [
                ...(prev.experiences || []),
                {
                    company_name: "",
                    designation: "",
                    start_date: "",
                    end_date: "",
                    location: "",
                    years_of_experience: "",
                    previous_drawn: "",
                },
            ],
        }));
    };
    const removeExperience = (index) => {
        setForm((prev) => ({ ...prev, experiences: (prev.experiences || []).filter((_, i) => i !== index) }));
    };
    // put this near your component (outside) or inside as a const
    const calcYearsBetween = (startStr, endStr) => {
        if (!startStr || !endStr) return "";
        const s = new Date(startStr);
        const e = new Date(endStr);
        if (isNaN(s) || isNaN(e) || e < s) return "0.00";
        const ms = e.getTime() - s.getTime();
        const years = ms / (365.2425 * 24 * 60 * 60 * 1000); // tropical year for better accuracy
        return years.toFixed(2);
    };

    const handleExpChange = (index, field, value) => {
        setForm(prev => {
            const experiences = [...(prev.experiences || [])];
            const row = { ...(experiences[index] || {}), [field]: value };


            if (field === "start_date" || field === "end_date") {
                if (row.start_date && row.end_date) {
                    row.years_of_experience = calcYearsBetween(row.start_date, row.end_date);
                } else {
                    row.years_of_experience = "";
                }
            }

            experiences[index] = row;
            return { ...prev, experiences };
        });
    };

    const startEditComp = (item) => {
        setSelectedSalaryComp({
            component_id: String(item.salary_component_id),
            amount: String(item.amount),
        });
        setEditingCompId(item.salary_component_id);
    };

    const cancelEditComp = () => {
        setSelectedSalaryComp({ component_id: "", amount: "" });
        setEditingCompId(null);
    };

    // Replace your existing addSalaryComp with this "add or update" version:
    const addOrUpdateSalaryComp = () => {
        const id = Number(selectedSalaryComp.component_id);
        const amt = Number(selectedSalaryComp.amount);

        if (!id || isNaN(amt) || amt < 0) {
            toast.error("Select a component and enter a valid amount");
            return;
        }

        setSalaryBreakup((prev) => {
            const next = [...prev];
            const i = next.findIndex((x) => x.salary_component_id === id);
            const existing = i >= 0 ? next[i] : {};

            const row = {
                // keep DB IDs if present
                employee_salary_component_id: existing.employee_salary_component_id ?? null,
                employee_salary_id: form.employee_salary_id ? Number(form.employee_salary_id) : null,
                salary_component_id: id,
                amount: amt,
                // preserve prior flags unless overriding with salary header
                is_current: existing.is_current ?? (form.is_current || "Y"),
                component_type: existing.component_type,
                is_deduction: existing.is_deduction,
                component_name: existing.component_name,
            };

            if (i >= 0) next[i] = row; // update existing
            else next.push(row);        // add new

            return next;
        });

        setSelectedSalaryComp({ component_id: "", amount: "" });
        setEditingCompId(null);
    };
    const [deletingCompId, setDeletingCompId] = useState(null);

    const removeSalaryComp = async (id) => {
        // find the row by salary_component_id
        const row = (salaryBreakup || []).find(r => Number(r.salary_component_id) === Number(id));
        if (!row) return;

        const savedEscId = Number(row.employee_salary_component_id || 0);
        const hasPersistedRow = savedEscId > 0;                    // this specific row is saved
        const hasPersistedSalary = Boolean(form.employee_salary_id); // salary header exists (edit flow)

        // CREATE flow or UNSAVED row -> remove locally only
        if (!hasPersistedRow || !hasPersistedSalary) {
            setSalaryBreakup(prev => prev.filter(x => Number(x.salary_component_id) !== Number(id)));
            if (editingCompId === id) cancelEditComp();
            return;
        }

        // EDIT flow + SAVED row -> inactivate on server, then remove
        if (!window.confirm("Remove this component from the current salary?")) return;

        try {
            setDeletingCompId(savedEscId);
            await axios.post(`${baseUrl}/salarycomponent/inactivate/`, {
                employee_salary_component_id: savedEscId,

            });

            setSalaryBreakup(prev => prev.filter(x => Number(x.employee_salary_component_id) !== savedEscId));
            if (editingCompId === id) cancelEditComp();
            toast.success("Component inactivated");
        } catch (err) {
            const messages = extractErrorMessages(err?.response?.data);
            toast.error(messages[0] || "Failed to inactivate component");
        } finally {
            setDeletingCompId(null);
        }
    };


    const resetForm = () => {
        setEditEmpId(null);
        setForm((p) => ({
            ...p,
            firstname: "",
            surname: "",
            phonenumber: "",
            emp_code: "",
            email: "",
            address: "",
            roleid: "",
            city: "",
            state: "",
            country: "",
            gender: "",
            password: "",
            UAN: "",
            Aadhar: "",
            PF_No: "",
            dob: "",
            doj: "",
            dor: "",
            designation_id: "",
            is_married: "",
            deptid: "",
            employee_type_id: "",
            shift_id: "",
            Reporting_To: "",
            school_id: userObj.school_id ?? 0,
            Qualification: "",
            Previous_Experience: "",
            cash_bank_type_id: "",
            account_number: "",
            ifsc_code: "",
            account_name: "",
            bank_name: "",
            branch_name: "",
            location: "",
            createdby: userObj?.userid || userObj?.username || "",
            createddate: "",
            lastmodifiedby: userObj?.userid || userObj?.username || "",
            lastmodifieddate: "",
            experiences: [],
            educations: [],
            employee_salary_id: "",
            ctc: "",
            gross_salary: "",
            net_salary: "",
            effective_from: "",
            effective_to: "",
            is_current: "Y",
            revision_reason: "",
            grace_time: ""
        }));
        setSalaryBreakup([]);
    };

    // -------------------- Submit --------------------
    const generatePassword = () => {
        const length = 10;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%^&*!";
        let password = "";
        for (let i = 0; i < length; i++) password += charset.charAt(Math.floor(Math.random() * charset.length));
        return password;
    };
    const buildPayload = (customForm = null) => {
        const formData = customForm || form;

        const genderMap = { Male: "M", Female: "F", Other: "O", M: "M", F: "F", O: "O" };
        const normalizedGender = genderMap[formData.gender] ?? null;
        const passwordemp = editEmpId ? null : generatePassword();

        const toInt = (v) => (v === undefined || v === null || v === "" ? null : Number(v));
        const toFloat = (v) => (v === undefined || v === null || v === "" ? null : Number(v));
        const toDateOrNull = (v) => (v ? String(v) : null);
        const toYN = (v) => (v === true || v === "Y" ? "Y" : v === false || v === "N" ? "N" : null);

        // --- Experiences / Educations (WITH CERTIFICATE PATHS) ---
        const experiences = (formData.experiences || []).map((x) => ({
            emp_experience_id: toInt(x.emp_experience_id),
            organization_name: x.company_name?.trim() || null,
            designation: x.designation?.trim() || null,
            start_date: toDateOrNull(x.start_date),
            end_date: toDateOrNull(x.end_date),
            location: x.location?.trim() || null,
            years_of_experience: toFloat(x.years_of_experience),
            previous_drawn: toFloat(x.previous_drawn),
            exp_certificate_path: x.exp_certificate_path || null,
        }));

        // CRITICAL FIX: Ensure certificate_path is included with proper mapping
        const educations = (formData.educations || []).map((x) => ({
            emp_education_id: toInt(x.emp_education_id),
            degree_name: x.degree_name?.trim() || null,
            field_of_study: x.field_of_study?.trim() || null,
            institution_name: x.institution_name?.trim() || null,
            board_university: x.board_university?.trim() || null,
            graduation_year: toInt(x.graduation_year),
            percentage: toFloat(x.percentage),
            cgpa: toFloat(x.cgpa),
            certificate_path: x.certificate_path || null, // CRITICAL: This maps the uploaded filename
        }));

        // --- Bank ---
        const bankRow = {
            emp_bank_details_id: toInt(formData.emp_bank_details_id),
            account_number: (formData.account_number || "").trim() || null,
            ifsc_code: (formData.ifsc_code || "").trim() || null,
            account_name: (formData.account_name || "").trim() || null,
            bank_name: (formData.bank_name || "").trim() || null,
            branch_name: (formData.branch_name || "").trim() || null,
            location: (formData.location || "").trim() || null,
            school_id: userObj.school_id,
        };
        const bank_details = Object.values({
            account_number: bankRow.account_number,
            ifsc_code: bankRow.ifsc_code,
            account_name: bankRow.account_name,
            bank_name: bankRow.bank_name,
            branch_name: bankRow.branch_name,
            location: bankRow.location,
        }).some((v) => v) ? [bankRow] : null;

        // --- Salary ---
        const components = (salaryBreakup || [])
            .filter((x) => Number(x.salary_component_id) > 0 && Number(x.amount) > 0)
            .map((x) => ({
                employee_salary_component_id: toInt(x.employee_salary_component_id),
                salary_component_id: toInt(x.salary_component_id),
                component_amount: toFloat(x.amount),
                is_current: toYN(x.is_current) ?? toYN(formData.is_current) ?? "Y",
                school_id: userObj.school_id,
            }));

        const salaryRow = {
            employee_salary_id: toInt(formData.employee_salary_id),
            emp_id: toInt(editEmpId),
            ctc: toFloat(formData.ctc),
            gross_salary: toFloat(formData.gross_salary),
            net_salary: toFloat(formData.net_salary),
            effective_from: toDateOrNull(formData.effective_from),
            effective_to: toDateOrNull(formData.is_current === "Y" ? null : formData.effective_to),
            is_current: toYN(formData.is_current),
            revision_reason: (formData.revision_reason || "").trim() || null,
            school_id: userObj.school_id,
            createdby: userObj.user_id,
            createddate: null,
            lastmodifiedby: userObj.user_id,
            lastmodifieddate: null,
            components,
        };

        const hasSalary =
            [formData.ctc, formData.gross_salary, formData.effective_from, formData.effective_to, formData.revision_reason].some(
                (v) => v !== undefined && v !== null && String(v).trim() !== ""
            ) || components.length > 0;

        const salary = hasSalary ? [salaryRow] : null;

        // inline spouse toggle
        const isMarriedYN = toYN(formData.is_married);

        // Log education certificates for debugging
        console.log("=== BUILD PAYLOAD - EDUCATION CERTIFICATES ===");
        educations.forEach((edu, index) => {
            console.log(`Edu ${index + 1}:`, {
                degree: edu.degree_name,
                certificate_path: edu.certificate_path,
                has_certificate: !!edu.certificate_path,
                emp_education_id: edu.emp_education_id
            });
        });

        return {
            action: editEmpId ? "UPDATE" : "CREATE",
            emp_id: toInt(editEmpId),

            // ===== Basic Information =====
            firstname: formData.firstname?.trim() || null,
            surname: formData.surname?.trim() || null,
            phonenumber: formData.phonenumber?.trim() || null,
            email: formData.email?.trim() || null,
            emp_code: formData.emp_code?.trim() || null,
            address: formData.address?.trim() || null,
            roleid: toInt(formData.roleid),
            city: formData.city?.trim() || null,
            state_id: toInt(formData.state),
            country_id: toInt(formData.country),
            gender: normalizedGender,
            password:'123456', // null on UPDATE, random on CREATE
            uan: formData.UAN?.trim() || null,
            aadhar: formData.Aadhar?.trim() || null,
            pf_no: formData.PF_No?.trim() || null,
            esi_number: formData.esi_opted === "Y" ? (formData.esi_number?.trim() || null) : null,
            opted_for_esi: formData.esi_opted,
            dob: toDateOrNull(formData.dob),
            doj: toDateOrNull(formData.doj),
            dor: toDateOrNull(formData.dor),
            designation_id: toInt(formData.designation_id),
            is_married: isMarriedYN,
             grace_time: toInt(formData.grace_time),
            deptid: toInt(formData.deptid),
            cash_bank_type_id: toInt(formData.cash_bank_type_id),
            employee_type_id: toInt(formData.employee_type_id),
            esi_opted: formData.esi_opted === "Y" ? "Y" : "N",
            esi_number: (formData.esi_number || "").trim() || null,
            shift_id: toInt(formData.shift_id),
            reporting_to: toInt(formData.Reporting_To),

            school_id: userObj.school_id,
            is_active: "A",
            createdby: userObj.user_id,
            lastmodifiedby: userObj.user_id,

            // ===== Related Data =====
            bank_details,
            educations, // NOW INCLUDES CERTIFICATE PATHS
            experiences,
            salary,

            // ===== Family Details =====
            father_name: formData.father_name?.trim() || null,
            father_phone: formData.father_phone?.trim() || null,
            father_email: formData.father_email?.trim() || null,
            father_occupation: formData.father_occupation?.trim() || null,
            mother_name: formData.mother_name?.trim() || null,
            mother_phone: formData.mother_phone?.trim() || null,
            mother_email: formData.mother_email?.trim() || null,
            mother_occupation: formData.mother_occupation?.trim() || null,
            spouse_name: isMarriedYN === "Y" ? (formData.spouse_name?.trim() || null) : null,
            spouse_phone: isMarriedYN === "Y" ? (formData.spouse_phone?.trim() || null) : null,
            spouse_email: isMarriedYN === "Y" ? (formData.spouse_email?.trim() || null) : null,
            spouse_occupation: isMarriedYN === "Y" ? (formData.spouse_occupation?.trim() || null) : null,

            // ===== Children =====
            children: (formData.children || []).map((ch) => ({
                child_id: ch.child_id ?? null,
                child_name: ch.child_name?.trim() || null,
                child_dob: toDateOrNull(ch.child_dob),
                child_gender: ch.child_gender || null,
            })),
        };
    };

    const handleRemoveCertificate = (index) => {
        setForm(prev => {
            const list = [...(prev.educations || [])];
            const row = { ...(list[index] || {}) };

            // Clear both file and path
            row.certificate_file = null;
            row.certificate_path = null;
            row.certificate_uploading = false;
            row.certificate_upload_error = null;

            list[index] = row;
            return { ...prev, educations: list };
        });

        toast.info("Certificate removed");
    };

    // Add this near your education certificate handlers
    const handleExpCertificateChange = async (index, file) => {
        if (!file) return;

        // Validate file type
        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp"
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.error("Only PDF, JPEG, PNG, GIF, and WebP files are allowed");
            return;
        }

        // Validate file size (10MB max)
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            toast.error("File size too large (max 10 MB)");
            return;
        }

        // Update form state with the file
        setForm(prev => {
            const list = [...(prev.experiences || [])];
            const row = { ...(list[index] || {}) };
            row.certificate_file = file;
            row.exp_certificate_path = null; // Clear any existing path
            row.certificate_uploading = false;
            list[index] = row;
            return { ...prev, experiences: list };
        });

        toast.info(`Experience certificate "${file.name}" selected. It will be uploaded when you submit.`);
    };

    const handleRemoveExpCertificate = (index) => {
        setForm(prev => {
            const list = [...(prev.experiences || [])];
            const row = { ...(list[index] || {}) };

            // Clear both file and path
            row.certificate_file = null;
            row.exp_certificate_path = null;
            row.certificate_uploading = false;
            row.certificate_upload_error = null;

            list[index] = row;
            return { ...prev, experiences: list };
        });

        toast.info("Experience certificate removed");
    };


    const extractErrorMessages = (data) => {
        const d = data?.detail ?? data;
        if (!d) return ["Something went wrong"];
        if (typeof d === "string") return [d];
        if (Array.isArray(d)) {
            const msgs = d.map((it) => it?.msg || (typeof it === "string" ? it : null)).filter(Boolean);
            return msgs.length ? msgs : ["Validation error"];
        }
        if (typeof d === "object") {
            if (d.message) return [d.message];
            if (d.error && typeof d.error === "string") return [d.error];
        }
        return ["Unexpected error"];
    };
    // keep this near your component
    async function uploadPhotoIfAny({ baseUrl, file, school_id, branch_name, emp_code }) {
        if (!file) return null;

        // client-side checks (optional)
        const okTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/bmp"];
        if (!okTypes.includes(file.type)) throw new Error("Unsupported image type");
        const maxBytes = 5 * 1024 * 1024; // 5MB
        if (file.size > maxBytes) throw new Error("Image too large (max 5 MB)");

        const fd = new FormData();
        fd.append("file", file);
        fd.append("school_id", userObj.school_id);
        fd.append("branch_name", userObj.branch); // your org branch name
        if (emp_code) fd.append("emp_code", emp_code);

        const res = await fetch(`${baseUrl}/upload_photo`, { method: "POST", body: fd });
        if (!res.ok) throw new Error((await res.text().catch(() => "")) || "Photo upload failed");
        const data = await res.json();
        return data?.blob || data?.url || data?.path || null;
    }


    // Add this near your other upload function
    async function uploadCertificateFile({ baseUrl, file, school_id, emp_code, documentType = "education_certificate" }) {
        if (!file) return null;

        // Client-side validation
        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp"
        ];

        if (!allowedTypes.includes(file.type)) {
            throw new Error("Only PDF, JPEG, PNG, GIF, and WebP files are allowed");
        }

        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            throw new Error("File size too large (max 10 MB)");
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("school_id", school_id);
        if (emp_code) formData.append("emp_code", emp_code);
        formData.append("document_type", documentType);

        try {
            console.log("Uploading certificate file:", file.name);

            const response = await fetch(`${baseUrl}/uploads/upload/`, {
                method: "POST",
                body: formData,
            });

            console.log("Upload response status:", response.status);

            if (!response.ok) {
                let errorText;
                try {
                    const errorData = await response.json();
                    console.error("Upload error response:", errorData);
                    errorText = errorData.detail || errorData.message || errorData.error || "Certificate upload failed";
                } catch (parseError) {
                    errorText = await response.text();
                    console.error("Upload error text:", errorText);
                }
                throw new Error(errorText || `Upload failed with status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Upload success response:", data);

            // CRITICAL: Return the full location path from server response
            return data.location || data.path || data.filename || file.name;

        } catch (error) {
            console.error("Upload error:", error);
            throw new Error(error.message || "Certificate upload failed");
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // --- CERTIFICATE UPLOAD: Upload any pending education and experience certificates first ---
            let updatedEducations = [...(form.educations || [])];
            let updatedExperiences = [...(form.experiences || [])];
            let hasUploadErrors = false;

            console.log("Starting certificate upload process...");
            console.log("Initial educations:", updatedEducations);
            console.log("Initial experiences:", updatedExperiences);

            // Upload education certificates sequentially
            for (let index = 0; index < updatedEducations.length; index++) {
                const education = updatedEducations[index];

                // If there's a file but no path, we need to upload it
                if (education.certificate_file && !education.certificate_path) {
                    try {
                        console.log(`Uploading education certificate ${index + 1}:`, education.certificate_file.name);

                        // Show loading state
                        updatedEducations[index] = {
                            ...updatedEducations[index],
                            certificate_uploading: true,
                            certificate_upload_error: null
                        };

                        // Upload the certificate file and get the full path
                        const uploadedPath = await uploadCertificateFile({
                            baseUrl,
                            file: education.certificate_file,
                            school_id: userObj.school_id,
                            emp_code: form.emp_code,
                            documentType: "education_certificate"
                        });

                        console.log(`Education certificate upload successful for index ${index + 1}, returned path:`, uploadedPath);

                        // Update the education record with the uploaded file path
                        updatedEducations[index] = {
                            ...updatedEducations[index],
                            certificate_path: uploadedPath,
                            certificate_file: null,
                            certificate_uploading: false,
                            certificate_upload_error: null
                        };

                        console.log(`Certificate path "${uploadedPath}" mapped to certificate_path for education ${index + 1}`);

                    } catch (certErr) {
                        console.error(`Education certificate upload failed for index ${index + 1}:`, certErr);

                        updatedEducations[index] = {
                            ...updatedEducations[index],
                            certificate_uploading: false,
                            certificate_upload_error: certErr.message
                        };

                        hasUploadErrors = true;
                        toast.error(`Failed to upload education certificate: ${certErr.message}`);
                    }
                }
            }

            // Upload experience certificates sequentially
            for (let index = 0; index < updatedExperiences.length; index++) {
                const experience = updatedExperiences[index];

                // If there's a file but no path, we need to upload it
                if (experience.certificate_file && !experience.exp_certificate_path) {
                    try {
                        console.log(`Uploading experience certificate ${index + 1}:`, experience.certificate_file.name);

                        // Show loading state
                        updatedExperiences[index] = {
                            ...updatedExperiences[index],
                            certificate_uploading: true,
                            certificate_upload_error: null
                        };

                        // Upload the certificate file and get the full path
                        const uploadedPath = await uploadCertificateFile({
                            baseUrl,
                            file: experience.certificate_file,
                            school_id: userObj.school_id,
                            emp_code: form.emp_code,
                            documentType: "experience_certificate"
                        });

                        console.log(`Experience certificate upload successful for index ${index + 1}, returned path:`, uploadedPath);

                        // Update the experience record with the uploaded file path
                        updatedExperiences[index] = {
                            ...updatedExperiences[index],
                            exp_certificate_path: uploadedPath,
                            certificate_file: null,
                            certificate_uploading: false,
                            certificate_upload_error: null
                        };

                        console.log(`Certificate path "${uploadedPath}" mapped to exp_certificate_path for experience ${index + 1}`);

                    } catch (certErr) {
                        console.error(`Experience certificate upload failed for index ${index + 1}:`, certErr);

                        updatedExperiences[index] = {
                            ...updatedExperiences[index],
                            certificate_uploading: false,
                            certificate_upload_error: certErr.message
                        };

                        hasUploadErrors = true;
                        toast.error(`Failed to upload experience certificate: ${certErr.message}`);
                    }
                }
            }

            // Stop submission if any certificate uploads failed
            if (hasUploadErrors) {
                toast.error("Please fix certificate upload errors before submitting");
                return;
            }

            // --- Build payload using updated educations and experiences (bypass React state timing issues) ---
            console.log("Building payload with updated certificate paths...");

            // Create temporary form data with updated data
            const tempFormData = {
                ...form,
                educations: updatedEducations,
                experiences: updatedExperiences
            };

            // Build payload using the updated form data
            const payload = buildPayload(tempFormData);

            // Debug: Verify certificate paths in final payload
            console.log("=== FINAL PAYLOAD VERIFICATION ===");
            if (payload.educations && payload.educations.length > 0) {
                payload.educations.forEach((edu, index) => {
                    console.log(`Edu ${index + 1}:`, {
                        degree: edu.degree_name,
                        certificate_path: edu.certificate_path,
                        has_certificate: !!edu.certificate_path,
                        emp_education_id: edu.emp_education_id
                    });
                });
            }

            if (payload.experiences && payload.experiences.length > 0) {
                payload.experiences.forEach((exp, index) => {
                    console.log(`Exp ${index + 1}:`, {
                        company: exp.organization_name,
                        exp_certificate_path: exp.exp_certificate_path,
                        has_certificate: !!exp.exp_certificate_path,
                        emp_experience_id: exp.emp_experience_id
                    });
                });
            }

            // --- Profile Photo Upload ---
            const orgBranchName = userObj?.branch_name || "main";
            let uploadedPath = null;

            if (form?.profile_photo_file) {
                try {
                    console.log("Uploading profile photo...");
                    uploadedPath = await uploadPhotoIfAny({
                        baseUrl,
                        file: form.profile_photo_file,
                        school_id: userObj.school_id,
                        branch_name: orgBranchName,
                        emp_code: payload.emp_code,
                    });
                    console.log("Profile photo upload successful:", uploadedPath);
                } catch (upErr) {
                    console.error("Profile photo upload failed:", upErr);
                    toast.error(upErr.message || "Profile photo upload failed");
                    return;
                }
            }

            // Update payload with profile photo path
            if (uploadedPath) {
                payload.profile_photo = uploadedPath;
            } else if (form?.profile_photo) {
                payload.profile_photo = form.profile_photo;
            } else {
                payload.profile_photo = null;
            }

            // Update React state for UI consistency
            setForm(prev => ({
                ...prev,
                educations: updatedEducations,
                experiences: updatedExperiences
            }));

            // Submit the complete payload
            console.log("Submitting employee data to backend...");
            console.log("Final payload:", JSON.stringify(payload, null, 2));

            const url = `${baseUrl}/create_or_update`;
            const response = await axios.post(url, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            });

            console.log("Submission successful:", response.data);

            toast.success(editEmpId ? "Employee updated successfully" : "Employee created successfully");

            // Reset form after successful submission if it's a new employee
            if (!editEmpId) {
                resetForm();
                setActiveKey("basic");
                if (photoPreviewUrl && photoPreviewUrl.startsWith("blob:")) {
                    URL.revokeObjectURL(photoPreviewUrl);
                }
                setPhotoPreviewUrl(null);
            }

        } catch (err) {
            console.error("Submission error:", err);

            if (!err?.response) {
                toast.error("Network error while submitting employee data");
                return;
            }

            const { status, data } = err.response;
            const messages = extractErrorMessages(data);

            switch (status) {
                case 400:
                    messages.forEach((m) => toast.error(m || "Bad request"));
                    break;
                case 409:
                    toast.error(messages[0] || "Duplicate Emp Code / Aadhar / PF / UAN");
                    break;
                case 422:
                    messages.forEach((m) => toast.error(m));
                    break;
                case 403:
                    toast.error(messages[0] || "You don't have permission to perform this action");
                    break;
                case 401:
                    toast.error(messages[0] || "Authentication required");
                    break;
                case 500:
                    toast.error(messages[0] || "Server error. Please try again.");
                    break;
                default:
                    toast.error(messages[0] || "Failed to submit employee data");
                    break;
            }
        }
    };

    // --- put near your other hooks ---
    const tabRefs = {
        basic: basicRef,
        education: educationRef,
        experience: experienceRef,
        parentdetails: parentRef,
        bank: bankRef,
        salary: salaryRef,
    };



    /** Returns true if invalid found (and focuses it), else false */
    const blockIfInvalid = (container) => {
        if (!container) return false;

        // prefer native constraint validation where possible
        // find the first invalid control inside this tab
        let invalid = container.querySelector(
            'input:invalid, select:invalid, textarea:invalid'
        );

        // handle required radio groups that don't always mark ':invalid' until submit
        if (!invalid) {
            const radiosGroups = Array.from(
                container.querySelectorAll('input[type="radio"][required]')
            ).reduce((m, el) => (m.add(el.name), m), new Set());
            for (const name of radiosGroups) {
                const group = container.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`);
                const anyChecked = Array.from(group).some((r) => r.checked);
                if (!anyChecked) {
                    invalid = group[0];
                    break;
                }
            }
        }

        if (invalid) {
            // try to show the browser message
            invalid.reportValidity?.();
            // scroll & focus to help the user
            invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            invalid.focus?.();
            // optional: toast error
            // toast.error("Please fill all required fields on this tab.");
            return true;
        }
        return false;
    };
    useEffect(() => {
        return () => {
            if (photoPreviewUrl && photoPreviewUrl.startsWith("blob:")) {
                try { URL.revokeObjectURL(photoPreviewUrl); } catch { }
            }
        };
    }, [photoPreviewUrl]);

    const fmtAmt = (n) =>
        Number.isFinite(Number(n || 0))
            ? Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : "0.00";

    return (
        <div className="">
            <ToastContainer />

            <div className="">


                <Card>
                    <Card.Body style={{ padding: 0 }}>
                        <Form onSubmit={handleSubmit}>
                            <div className="innerPageBody">
                                <Row>
                                    <Col xs={12}>
                                        <h6 className="commonSectionTitle">Employee</h6>
                                    </Col>
                                </Row>

                                <div className="tabs-sticky">
                                    <div className="position-relative">
                                        <Tabs
                                            activeKey={activeKey}
                                            onSelect={(k) => {
                                                if (!k || k === activeKey) return;
                                                const container = getCurrentContainer();
                                                if (blockIfInvalid(container)) return;   // ⬅️ block tab switch if invalid
                                                setActiveKey(k);
                                            }}
                                            className="mb-3 emp-tabs pe-5"
                                        >


                                            <Tab eventKey="basic" title="Basic Information">
                                                <div ref={basicRef} className="tabBodyScroll">
                                                    <Row>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        First Name <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        required
                                                                        id="firstname"
                                                                        value={form.firstname}
                                                                        placeholder="Enter First Name"
                                                                        maxLength={30}
                                                                        onChange={(e) => {
                                                                            const v = e.target.value;
                                                                            if (/^[A-Za-z\s]*$/.test(v)) handleInputChange(e);
                                                                        }}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Surname <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        required
                                                                        id="surname"
                                                                        value={form.surname}
                                                                        placeholder="Enter Surname"
                                                                        maxLength={30}
                                                                        onChange={(e) => {
                                                                            const v = e.target.value;
                                                                            if (/^[A-Za-z\s]*$/.test(v)) handleInputChange(e);
                                                                        }}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Employee Code <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        required
                                                                        id="emp_code"
                                                                        value={form.emp_code}
                                                                        placeholder="Enter Employee Code"
                                                                        maxLength={30}
                                                                        onChange={(e) => {
                                                                            const v = e.target.value;
                                                                            if (/^[A-Za-z0-9\s]*$/.test(v)) handleInputChange(e);
                                                                        }}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Phone Number <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        required
                                                                        id="phonenumber"
                                                                        value={form.phonenumber}
                                                                        placeholder="Enter Phone Number"
                                                                        maxLength={10}
                                                                        onChange={(e) => {
                                                                            const v = e.target.value;
                                                                            if (/^\d*$/.test(v)) handleInputChange(e);
                                                                        }}
                                                                        isInvalid={(form.phonenumber || "").length > 10}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Email <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        required
                                                                        type="email"
                                                                        id="email"
                                                                        value={form.email}
                                                                        placeholder="Enter Email"
                                                                        maxLength={150}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Role <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select required id="roleid" value={form.roleid} onChange={handleInputChange}>
                                                                        <option value="" disabled hidden>Select Role</option>
                                                                        {(roles || [])
                                                                            .filter((r) => r.is_active === "Active")
                                                                            .map((r) => (
                                                                                <option key={r.role_id} value={r.role_id}>
                                                                                    {r.role_name}
                                                                                </option>
                                                                            ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Department<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select id="deptid" value={form.deptid} onChange={handleInputChange} required>
                                                                        <option value="" disabled hidden>Select Department</option>
                                                                        {(departments || [])
                                                                            .filter((d) => d.is_active === "Active")
                                                                            .map((d) => (
                                                                                <option key={d.dept_id} value={d.dept_id}>
                                                                                    {d.dept_name}
                                                                                </option>
                                                                            ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Gender<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <div className="d-flex">
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input hii"
                                                                                type="radio"
                                                                                name="gender"
                                                                                id="male"
                                                                                value="Male"
                                                                                onChange={handleRadioChange}
                                                                                checked={form.gender === "Male"}
                                                                                required
                                                                            />
                                                                            <label className="form-check-label" htmlFor="active">
                                                                                Male
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check ms-3">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                name="gender"
                                                                                id="female"
                                                                                value="Female"
                                                                                onChange={handleRadioChange}
                                                                                checked={form.gender === "Female"}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="inactive">
                                                                                Female
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={12} lg={8} xxl={6}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Address<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        id="address"
                                                                        value={form.address}
                                                                        placeholder="Enter Address"
                                                                        onChange={handleInputChange}
                                                                        maxLength={250}
                                                                        rows="3"
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        City<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        id="city"
                                                                        value={form.city}
                                                                        placeholder="Enter City"
                                                                        maxLength={30}
                                                                        onChange={(e) => {
                                                                            const v = e.target.value;
                                                                            if (/^[A-Za-z\s]*$/.test(v)) handleInputChange(e);
                                                                        }}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        State<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select id="state" value={form.state} onChange={handleInputChange} required>
                                                                        <option value="" disabled hidden>Select State</option>
                                                                        {(states || []).map((s) => (
                                                                            <option key={s.state_id} value={s.state_id}>
                                                                                {s.state_name}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Country<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select id="country" value={form.country} onChange={handleInputChange} required>
                                                                        <option value="" disabled hidden>Select Country</option>
                                                                        {(countries || []).map((c) => (
                                                                            <option key={c.country_id} value={c.country_id}>
                                                                                {c.country_name}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        UAN<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        id="UAN"
                                                                        value={form.UAN}
                                                                        maxLength={15}
                                                                        placeholder="Enter UAN"
                                                                        onChange={digitsOnly("UAN")}
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Aadhar<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        id="Aadhar"
                                                                        value={form.Aadhar}
                                                                        placeholder="12-digit Aadhar"
                                                                        onChange={handleAadhar}
                                                                        maxLength={12}
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        PF No.<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        id="PF_No"
                                                                        value={form.PF_No}
                                                                        placeholder="Enter PF No."
                                                                        onChange={(e) => setForm((p) => ({ ...p, PF_No: e.target.value.toUpperCase() }))}
                                                                        maxLength={25}
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        {/* <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Opted for ESI? <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <div className="d-flex gap-3">
                                                                        <Form.Check
                                                                            type="radio"
                                                                            label="Yes"
                                                                            name="esi_opted"
                                                                            id="esi_opted_y"
                                                                            checked={form.esi_opted === "Y"}
                                                                            onChange={() => setForm(p => ({ ...p, esi_opted: "Y" }))}
                                                                            required
                                                                        />
                                                                        <Form.Check
                                                                            type="radio"
                                                                            label="No"
                                                                            name="esi_opted"
                                                                            id="esi_opted_n"
                                                                            checked={form.esi_opted === "N"}
                                                                            onChange={() => setForm(p => ({ ...p, esi_opted: "N", esi_number: "" }))}
                                                                        />
                                                                    </div>
                                                                </Form.Group>
                                                            </div>
                                                        </Col> */}

                                                        {/* Add this after PF No field */}
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Opted for ESI? <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <div className="d-flex gap-3">
                                                                        <Form.Check
                                                                            type="radio"
                                                                            label="Yes"
                                                                            name="esi_opted"
                                                                            id="esi_opted_y"
                                                                            checked={form.esi_opted === "Y"}
                                                                            onChange={() => setForm(p => ({ ...p, esi_opted: "Y" }))}
                                                                            required
                                                                        />
                                                                        <Form.Check
                                                                            type="radio"
                                                                            label="No"
                                                                            name="esi_opted"
                                                                            id="esi_opted_n"
                                                                            checked={form.esi_opted === "N"}
                                                                            onChange={() => setForm(p => ({ ...p, esi_opted: "N", esi_number: "" }))}
                                                                        />
                                                                    </div>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        {form.esi_opted === "Y" && (
                                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                                <div className="commonInput">
                                                                    <Form.Group>
                                                                        <Form.Label>
                                                                            ESI Number <span className="requiredStar">*</span>
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            id="esi_number"
                                                                            type="number"
                                                                            value={form.esi_number}
                                                                            placeholder="Enter ESI Number"
                                                                            maxLength={30}
                                                                            min={0} // prevent negative numbers
                                                                            required={form.esi_opted === "Y"}
                                                                            onChange={e => {
                                                                                const value = e.target.value;
                                                                                // only allow empty or non-negative numbers
                                                                                if (/^\d*$/.test(value)) {
                                                                                    setForm(p => ({ ...p, esi_number: value }));
                                                                                }
                                                                            }}
                                                                            onKeyDown={e => {
                                                                                // prevent 'e', '+', '-', and '.' characters
                                                                                if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                                                    e.preventDefault();
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </Col>
                                                        )}


                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Date of Birth<span className="requiredStar">*</span>
                                                                    </Form.Label>



                                                                    <Form.Control
                                                                        type="date"
                                                                        id="dob"
                                                                        value={form.dob || ""}
                                                                        onChange={(e) => {
                                                                            const v = e.target.value;
                                                                            // prevent typing a future date
                                                                            if (v > todayLocal) return;
                                                                            handleInputChange(e);
                                                                        }}
                                                                        required
                                                                        max={todayLocal}   // <-- disables all future dates in the picker
                                                                    />

                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Date of Joining<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="date"
                                                                        id="doj"
                                                                        required
                                                                        value={form.doj || ""}
                                                                        // allow any past date, block future
                                                                        onChange={handleInputChange}
                                                                    />
                                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Designation <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select required id="designation_id" value={form.designation_id} onChange={handleInputChange}>
                                                                        <option value="" disabled hidden>Select Designation</option>
                                                                        {(designations || []).map((dg) => (
                                                                            <option key={dg.designation_id} value={dg.designation_id}>
                                                                                {dg.description || dg.description}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Employee Type <span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select
                                                                        required
                                                                        id="employee_type_id"
                                                                        value={form.employee_type_id || ""}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="" disabled hidden>Select Employee Type</option>
                                                                        {(employeeTypes || []).map((et) => (
                                                                            <option key={et.employee_type_id} value={et.employee_type_id}>
                                                                                {et.employee_type_name}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Shift<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select id="shift_id" value={form.shift_id} onChange={handleInputChange} required>
                                                                        <option value="" disabled hidden>Select Shift</option>
                                                                        {(shifts || []).map((s) => (
                                                                            <option key={s.shift_id} value={s.shift_id}>
                                                                                {s.shift_name}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Cash/Bank Code<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Select id="cash_bank_type_id" value={form.cash_bank_type_id} onChange={handleInputChange} required>
                                                                        <option value="" disabled hidden>Select Cash/Bank</option>
                                                                        {(banks || []).map((b) => (
                                                                            <option key={b.cash_bank_type_id} value={b.cash_bank_type_id}>
                                                                                {b.cash_bank_type_name || b.cash_bank_type_name}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Reporting To
                                                                    </Form.Label>
                                                                    <Form.Select id="Reporting_To" value={form.Reporting_To} onChange={handleInputChange} >
                                                                        <option value="" disabled hidden>Select Manager</option>
                                                                        {(managers || []).map((m) => (
                                                                            <option key={m.emp_id} value={m.emp_id}>
                                                                                {m.emp_name}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Date of Resignation</Form.Label>
                                                                    <Form.Control type="date" id="dor" value={form.dor || ""} onChange={handleInputChange} min={form.doj || ""} />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Profile Photo</Form.Label>

                                                                    <Form.Control
                                                                        type="file"
                                                                        accept="image/*"
                                                                        onChange={(e) => {
                                                                            const file = e.target.files?.[0] || null;
                                                                            setForm((p) => ({ ...p, profile_photo_file: file }));
                                                                            setPhotoPreviewUrl((old) => {
                                                                                if (old && old.startsWith("blob:")) {
                                                                                    try { URL.revokeObjectURL(old); } catch { }
                                                                                }
                                                                                return file
                                                                                    ? URL.createObjectURL(file)
                                                                                    : buildEmployeeImageUrl(baseUrl, form.profile_photo);
                                                                            });
                                                                        }}
                                                                    />

                                                                    {/* Preview */}
                                                                    {photoPreviewUrl ? (
                                                                        <img
                                                                            src={photoPreviewUrl}
                                                                            alt="preview"
                                                                            style={{ height: 80, borderRadius: 8, marginTop: 8 }}
                                                                        />
                                                                    ) : form?.profile_photo ? (
                                                                        <img
                                                                            src={buildEmployeeImageUrl(baseUrl, form.profile_photo)}
                                                                            alt="current"
                                                                            style={{ height: 80, borderRadius: 8, marginTop: 8 }}
                                                                        />
                                                                    ) : null}
                                                                </Form.Group>
                                                            </div>
                                                        </Col>


                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Marital Status<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <div className="d-flex gap-3">
                                                                        <Form.Check
                                                                            type="radio"
                                                                            label="Married"
                                                                            name="marital"
                                                                            id="is_married_y"
                                                                            checked={form.is_married === "Y"}
                                                                            onChange={() => setForm((p) => ({ ...p, is_married: "Y" }))}
                                                                            required
                                                                        />
                                                                        <Form.Check
                                                                            type="radio"
                                                                            label="Unmarried"
                                                                            name="marital"
                                                                            id="is_married_n"
                                                                            checked={form.is_married === "N"}
                                                                            onChange={() => setForm((p) => ({ ...p, is_married: "N" }))}
                                                                        />
                                                                    </div>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Grace Time<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                   {/* // In your grace_time input field, make sure the onChange is working properly */}
<Form.Control
    type="number"
    id="grace_time"
    value={form.grace_time ?? ""}
    placeholder="Enter Grace Time"
    min={0}
    onChange={(e) => {
        const value = e.target.value;
        console.log("Grace time changed to:", value); // Debug log
        
        setForm((prev) => ({
            ...prev,
            grace_time: value === "" ? "" : parseInt(value) 
        }));
    }}
    required
/>


                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Tab>

                                            {/* ---------------- EDUCATION ---------------- */}
                                            <Tab eventKey="education" title="Education Information">
                                                <div ref={educationRef} className="tabBodyScroll">
                                                    <Row className="mb-2">
                                                        <Col xs={12} className="d-flex justify-content-end">
                                                            <Button className="btn btn-success primaryBtn" onClick={addEducation}>
                                                                + Add Education
                                                            </Button>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xs={12}>
                                                            {(form.educations || []).map((edu, index) => (
                                                                <div key={index} className="border rounded p-3 mb-3">
                                                                    <Row className="g-2">
                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        Name Of The Degree <span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        value={edu.degree_name || ""}
                                                                                        placeholder="e.g., B.Tech / MBA"
                                                                                        onChange={(e) => handleEduChange(index, "degree_name", e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        Field of Study<span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        value={edu.field_of_study || ""}
                                                                                        placeholder="e.g., Electronics, CS"
                                                                                        onChange={(e) => handleEduChange(index, "field_of_study", e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        Institution Name <span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        value={edu.institution_name || ""}
                                                                                        placeholder="College / School"
                                                                                        onChange={(e) => handleEduChange(index, "institution_name", e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        Board / University <span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        value={edu.board_university || ""}
                                                                                        placeholder="e.g., JNTU, CBSE"
                                                                                        onChange={(e) => handleEduChange(index, "board_university", e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={3} xxl={2}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Graduation Year</Form.Label>
                                                                                    <Form.Control
                                                                                        type="number"
                                                                                        min="1900"
                                                                                        max="2100"
                                                                                        value={edu.graduation_year || ""}
                                                                                        placeholder="YYYY"
                                                                                        onChange={(e) => handleEduChange(index, "graduation_year", e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={3} xxl={2}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Percentage</Form.Label>
                                                                                    <Form.Control
                                                                                        inputMode="decimal"
                                                                                        step="0.01"
                                                                                        placeholder="0–100"
                                                                                        value={edu.percentage || ""}
                                                                                        onChange={(e) => handleEduChange(index, "percentage", e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={3} xxl={2}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>CGPA</Form.Label>
                                                                                    <Form.Control
                                                                                        inputMode="decimal"
                                                                                        step="0.01"
                                                                                        placeholder="e.g., 8.5"
                                                                                        value={edu.cgpa || ""}
                                                                                        onChange={(e) => handleEduChange(index, "cgpa", e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Certificate (PDF/Image)</Form.Label>

                                                                                    {/* ✅ Always show file input */}
                                                                                    <Form.Control
                                                                                        type="file"
                                                                                        accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,image/*"
                                                                                        onChange={async (e) => {
                                                                                            const file = e.target.files?.[0] || null;
                                                                                            if (!file) return;

                                                                                            console.log("File selected for upload:", file.name);

                                                                                            // Validate file type
                                                                                            const allowedTypes = [
                                                                                                "application/pdf",
                                                                                                "image/jpeg",
                                                                                                "image/png",
                                                                                                "image/gif",
                                                                                                "image/webp"
                                                                                            ];

                                                                                            if (!allowedTypes.includes(file.type)) {
                                                                                                toast.error("Only PDF, JPEG, PNG, GIF, and WebP files are allowed");
                                                                                                e.target.value = "";
                                                                                                return;
                                                                                            }

                                                                                            // Validate file size (10MB max)
                                                                                            const maxSize = 10 * 1024 * 1024;
                                                                                            if (file.size > maxSize) {
                                                                                                toast.error("File size too large (max 10 MB)");
                                                                                                e.target.value = "";
                                                                                                return;
                                                                                            }

                                                                                            // Update form state with the file
                                                                                            setForm(prev => {
                                                                                                const list = [...(prev.educations || [])];
                                                                                                const row = { ...(list[index] || {}) };
                                                                                                row.certificate_file = file;
                                                                                                row.certificate_path = null; // Clear any existing path
                                                                                                row.certificate_uploading = false;
                                                                                                list[index] = row;
                                                                                                return { ...prev, educations: list };
                                                                                            });

                                                                                            toast.info(`Certificate "${file.name}" selected. It will be uploaded when you submit.`);
                                                                                        }}
                                                                                        disabled={edu.certificate_uploading}
                                                                                    />

                                                                                    {/* Upload status */}
                                                                                    <div className="mt-1">
                                                                                        {edu.certificate_uploading && (
                                                                                            <small className="text-info">
                                                                                                <Spinner animation="border" size="sm" className="me-1" />
                                                                                                Uploading certificate...
                                                                                            </small>
                                                                                        )}

                                                                                        {/* ✅ If there's already a saved certificate from DB, show hyperlink */}
                                                                                        {edu.certificate_path && typeof edu.certificate_path === "string" && !edu.certificate_uploading && (
                                                                                            <div className="d-flex align-items-center mt-2">
                                                                                                <a
                                                                                                    href={`${baseUrl}/uploads/get-image/${encodeURIComponent(
                                                                                                        edu.certificate_path.replace(/^uploads[\\/]/, "")
                                                                                                    )}`}
                                                                                                    target="_blank"
                                                                                                    rel="noopener noreferrer"
                                                                                                    download={edu.certificate_path.split(/[\\/]/).pop()}
                                                                                                    style={{
                                                                                                        textDecoration: "none",
                                                                                                        color: "#007bff",
                                                                                                        wordBreak: "break-all",
                                                                                                    }}
                                                                                                >
                                                                                                    📎 {edu.certificate_path.split(/[\\/]/).pop()}
                                                                                                </a>
                                                                                                <Button
                                                                                                    variant="danger"
                                                                                                    size="sm"
                                                                                                    className="ms-2"
                                                                                                    onClick={() => handleRemoveCertificate(index)}
                                                                                                >
                                                                                                    X
                                                                                                </Button>
                                                                                            </div>
                                                                                        )}

                                                                                        {/* ✅ If a new file was just selected (not yet uploaded), show its name */}
                                                                                        {edu.certificate_file && !edu.certificate_path && !edu.certificate_uploading && (
                                                                                            <div className="d-flex align-items-center mt-2">
                                                                                                <span className="me-2 text-warning">📄 {edu.certificate_file.name}</span>
                                                                                                <Button
                                                                                                    variant="danger"
                                                                                                    size="sm"
                                                                                                    onClick={() => handleRemoveCertificate(index)}
                                                                                                >
                                                                                                    X
                                                                                                </Button>
                                                                                            </div>
                                                                                        )}

                                                                                        {edu.certificate_upload_error && (
                                                                                            <small className="text-danger">
                                                                                                Upload failed: {edu.certificate_upload_error}
                                                                                            </small>
                                                                                        )}
                                                                                    </div>
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>


                                                                        <Col xs={12} md={1} className="d-flex align-items-center justify-content-center">
                                                                            <span
                                                                                style={{ cursor: "pointer", fontSize: "24px", color: "red", fontWeight: "bold", lineHeight: "1" }}
                                                                                onClick={() => removeEducation(index)}
                                                                                title="Remove"
                                                                            >
                                                                                –
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            ))}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Tab>

                                            {/* ---------------- EXPERIENCE ---------------- */}
                                            <Tab eventKey="experience" title="Experience">
                                                <div ref={experienceRef} className="tabBodyScroll">
                                                    <Row>
                                                        <Col xs={12} className="d-flex justify-content-end mb-2">
                                                            <Button className="btn btn-success primaryBtn" onClick={addExperience}>
                                                                + Add Experience
                                                            </Button>
                                                        </Col>

                                                        <Col xs={12}>
                                                            {(form.experiences || []).map((exp, index) => (
                                                                <div key={index} className="border rounded p-3 mb-3">
                                                                    <Row className="g-2">
                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        Organization Name <span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        value={exp.company_name || ""}
                                                                                        placeholder="Enter Company Name"
                                                                                        onChange={(e) => handleExpChange(index, "company_name", e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        Designation/Role <span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        value={exp.designation || ""}
                                                                                        onChange={(e) => handleExpChange(index, "designation", e.target.value)}
                                                                                        required
                                                                                        placeholder="Enter designation"
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Location</Form.Label>
                                                                                    <Form.Control
                                                                                        value={exp.location || ""}
                                                                                        placeholder="City / Country"
                                                                                        onChange={(e) => handleExpChange(index, "location", e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        Start Date <span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        type="date"
                                                                                        value={exp.start_date || ""}
                                                                                        onChange={(e) => handleExpChange(index, "start_date", e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>
                                                                                        End Date <span className="requiredStar">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        type="date"
                                                                                        value={exp.end_date || ""}
                                                                                        min={exp.start_date || ""}
                                                                                        onChange={(e) => handleExpChange(index, "end_date", e.target.value)}
                                                                                        required
                                                                                        isInvalid={exp.start_date && exp.end_date && new Date(exp.end_date) < new Date(exp.start_date)}
                                                                                    />
                                                                                    <Form.Control.Feedback type="invalid">
                                                                                        End Date cannot be before Start Date.
                                                                                    </Form.Control.Feedback>

                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Years of Experience</Form.Label>
                                                                                    <Form.Control
                                                                                        value={exp.years_of_experience || ""}
                                                                                        readOnly
                                                                                        plaintext={false}
                                                                                        inputMode="decimal"
                                                                                        placeholder="Auto"
                                                                                        title="Automatically calculated from Start/End dates"
                                                                                    />

                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>
                                                                        {/* Add this after Years of Experience field in Experience tab */}
                                                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Previous Drawn Amount</Form.Label>
                                                                                    <Form.Control
                                                                                        type="number"
                                                                                        inputMode="decimal"
                                                                                        min="0"
                                                                                        step="0.01"
                                                                                        placeholder="e.g., 35000.00"
                                                                                        value={exp.previous_drawn ?? ""}
                                                                                        onChange={(e) => {
                                                                                            const val = e.target.value;
                                                                                            setForm(prev => {
                                                                                                const list = [...(prev.experiences || [])];
                                                                                                const row = { ...(list[index] || {}) };
                                                                                                row.previous_drawn = val;
                                                                                                list[index] = row;
                                                                                                return { ...prev, experiences: list };
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Experience Certificate (PDF/Image)</Form.Label>

                                                                                    <Form.Control
                                                                                        type="file"
                                                                                        accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,image/*"
                                                                                        onChange={(e) => {
                                                                                            const file = e.target.files?.[0] || null;
                                                                                            if (file) {
                                                                                                handleExpCertificateChange(index, file);
                                                                                            }
                                                                                            e.target.value = ""; // Reset input to allow re-uploading same file
                                                                                        }}
                                                                                        disabled={exp.certificate_uploading}
                                                                                    />

                                                                                    {/* Upload status */}
                                                                                    <div className="mt-1">
                                                                                        {exp.certificate_uploading && (
                                                                                            <small className="text-info">
                                                                                                <Spinner animation="border" size="sm" className="me-1" />
                                                                                                Uploading certificate...
                                                                                            </small>
                                                                                        )}

                                                                                        {/* Show existing certificate from DB */}
                                                                                        {exp.exp_certificate_path && typeof exp.exp_certificate_path === "string" && !exp.certificate_uploading && (
                                                                                            <div className="d-flex align-items-center mt-2">
                                                                                                <a
                                                                                                    href={`${baseUrl}/uploads/get-image/${encodeURIComponent(
                                                                                                        exp.exp_certificate_path.replace(/^uploads[\\/]/, "")
                                                                                                    )}`}
                                                                                                    target="_blank"
                                                                                                    rel="noopener noreferrer"
                                                                                                    download={exp.exp_certificate_path.split(/[\\/]/).pop()}
                                                                                                    style={{
                                                                                                        textDecoration: "none",
                                                                                                        color: "#007bff",
                                                                                                        wordBreak: "break-all",
                                                                                                    }}
                                                                                                >
                                                                                                    📎 {exp.exp_certificate_path.split(/[\\/]/).pop()}
                                                                                                </a>
                                                                                                <Button
                                                                                                    variant="danger"
                                                                                                    size="sm"
                                                                                                    className="ms-2"
                                                                                                    onClick={() => handleRemoveExpCertificate(index)}
                                                                                                >
                                                                                                    X
                                                                                                </Button>
                                                                                            </div>
                                                                                        )}

                                                                                        {/* Show newly selected file (not yet uploaded) */}
                                                                                        {exp.certificate_file && !exp.exp_certificate_path && !exp.certificate_uploading && (
                                                                                            <div className="d-flex align-items-center mt-2">
                                                                                                <span className="me-2 text-warning">📄 {exp.certificate_file.name}</span>
                                                                                                <Button
                                                                                                    variant="danger"
                                                                                                    size="sm"
                                                                                                    onClick={() => handleRemoveExpCertificate(index)}
                                                                                                >
                                                                                                    X
                                                                                                </Button>
                                                                                            </div>
                                                                                        )}

                                                                                        {exp.certificate_upload_error && (
                                                                                            <small className="text-danger">
                                                                                                Upload failed: {exp.certificate_upload_error}
                                                                                            </small>
                                                                                        )}
                                                                                    </div>
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>






                                                                        <Col xs={12} md={1} className="d-flex align-items-center justify-content-center">
                                                                            <span
                                                                                style={{ cursor: "pointer", fontSize: "24px", color: "red", fontWeight: "bold", lineHeight: "1" }}
                                                                                onClick={() => removeExperience(index)}
                                                                                title="Remove"
                                                                            >
                                                                                –
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            ))}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Tab>
                                            <Tab eventKey="parentdetails" title="Family Details">
                                                <div ref={parentRef} className="tabBodyScroll">
                                                    <Row className="mb-2">
                                                        <Col xs={12}><h6 className="commonSectionTitle">Father Details</h6></Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Father Name <span className="requiredStar">*</span></Form.Label>
                                                                    <Form.Control
                                                                        id="father_name"
                                                                        value={form.father_name}
                                                                        onChange={handleInputChange}
                                                                        placeholder="Enter Father Name"
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Father Phone <span className="requiredStar">*</span></Form.Label>
                                                                    <Form.Control
                                                                        id="father_phone"
                                                                        value={form.father_phone}
                                                                        onChange={(e) => { const v = e.target.value; if (/^\d*$/.test(v)) handleInputChange(e); }}
                                                                        placeholder="10-digit number"
                                                                        maxLength={10}
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Father Email</Form.Label>
                                                                    <Form.Control
                                                                        type="email"
                                                                        id="father_email"
                                                                        value={form.father_email}
                                                                        onChange={handleInputChange}
                                                                        placeholder="Enter Email"
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Father Occupation</Form.Label>
                                                                    <Form.Control
                                                                        id="father_occupation"
                                                                        value={form.father_occupation}
                                                                        onChange={handleInputChange}
                                                                        placeholder="e.g., Engineer"
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <hr className="my-3" />

                                                    <Row className="mb-2">
                                                        <Col xs={12}><h6 className="commonSectionTitle">Mother Details</h6></Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Mother Name <span className="requiredStar">*</span></Form.Label>
                                                                    <Form.Control
                                                                        id="mother_name"
                                                                        value={form.mother_name}
                                                                        onChange={handleInputChange}
                                                                        placeholder="Enter Mother Name"
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Mother Phone <span className="requiredStar">*</span></Form.Label>
                                                                    <Form.Control
                                                                        id="mother_phone"
                                                                        value={form.mother_phone}
                                                                        onChange={(e) => { const v = e.target.value; if (/^\d*$/.test(v)) handleInputChange(e); }}
                                                                        placeholder="10-digit number"
                                                                        maxLength={10}
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Mother Email</Form.Label>
                                                                    <Form.Control
                                                                        type="email"
                                                                        id="mother_email"
                                                                        value={form.mother_email}
                                                                        onChange={handleInputChange}
                                                                        placeholder="Enter Email"
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>Mother Occupation</Form.Label>
                                                                    <Form.Control
                                                                        id="mother_occupation"
                                                                        value={form.mother_occupation}
                                                                        onChange={handleInputChange}
                                                                        placeholder="e.g., Teacher"
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                    </Row>


                                                    {form.is_married === "Y" && (
                                                        <Row className="mb-2">
                                                            <Col xs={12}><h6 className="commonSectionTitle">Spouse Details</h6></Col>

                                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                                <div className="commonInput">
                                                                    <Form.Group>
                                                                        <Form.Label>Spouse Name <span className="requiredStar">*</span></Form.Label>
                                                                        <Form.Control
                                                                            id="spouse_name"
                                                                            value={form.spouse_name}
                                                                            onChange={handleInputChange}
                                                                            placeholder="Enter Spouse Name"
                                                                            required
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </Col>

                                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                                <div className="commonInput">
                                                                    <Form.Group>
                                                                        <Form.Label>Spouse Phone <span className="requiredStar">*</span></Form.Label>
                                                                        <Form.Control
                                                                            id="spouse_phone"
                                                                            value={form.spouse_phone}
                                                                            onChange={(e) => { const v = e.target.value; if (/^\d*$/.test(v)) handleInputChange(e); }}
                                                                            placeholder="10-digit number"
                                                                            maxLength={10}
                                                                            required
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </Col>

                                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                                <div className="commonInput">
                                                                    <Form.Group>
                                                                        <Form.Label>Spouse Email</Form.Label>
                                                                        <Form.Control
                                                                            type="email"
                                                                            id="spouse_email"
                                                                            value={form.spouse_email}
                                                                            onChange={handleInputChange}
                                                                            placeholder="name@email.com"
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </Col>

                                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                                <div className="commonInput">
                                                                    <Form.Group>
                                                                        <Form.Label>Spouse Occupation</Form.Label>
                                                                        <Form.Control
                                                                            id="spouse_occupation"
                                                                            value={form.spouse_occupation}
                                                                            onChange={handleInputChange}
                                                                            placeholder="e.g., Teacher"
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    )}



                                                    <hr className="my-3" />

                                                    <Row className="mb-2">
                                                        <Col xs={12} className="d-flex align-items-center justify-content-between">
                                                            <h6 className="commonSectionTitle mb-0">Children</h6>
                                                            <Button className="btn btn-success primaryBtn" onClick={addChild}>+ Add Child</Button>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xs={12}>
                                                            {(form.children || []).map((c, index) => (
                                                                <div key={index} className="border rounded p-3 mb-3">
                                                                    <Row className="g-2">
                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Child Name <span className="requiredStar">*</span></Form.Label>
                                                                                    <Form.Control
                                                                                        value={c.child_name || ""}
                                                                                        onChange={(e) => handleChildChange(index, "child_name", e.target.value)}
                                                                                        placeholder="Enter Name"
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Child DOB</Form.Label>
                                                                                    <Form.Control
                                                                                        type="date"
                                                                                        value={c.child_dob || ""}
                                                                                        onChange={(e) => handleChildChange(index, "child_dob", e.target.value)}
                                                                                        max={new Date().toISOString().split("T")[0]}
                                                                                    />
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        {/* Replace the existing Gender <Col> with this */}
                                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                                            <div className="commonInput">
                                                                                <Form.Group>
                                                                                    <Form.Label>Gender <span className="requiredStar">*</span></Form.Label>
                                                                                    <div className="d-flex gap-3">
                                                                                        <Form.Check
                                                                                            type="radio"
                                                                                            label="Male"
                                                                                            name={`child_gender_${index}`}
                                                                                            id={`child_gender_m_${index}`}
                                                                                            value="M"
                                                                                            checked={c.child_gender === "M"}
                                                                                            onChange={(e) => handleChildChange(index, "child_gender", e.target.value)}
                                                                                            required
                                                                                        />
                                                                                        <Form.Check
                                                                                            type="radio"
                                                                                            label="Female"
                                                                                            name={`child_gender_${index}`}
                                                                                            id={`child_gender_f_${index}`}
                                                                                            value="F"
                                                                                            checked={c.child_gender === "F"}
                                                                                            onChange={(e) => handleChildChange(index, "child_gender", e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                </Form.Group>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={1} className="d-flex align-items-center justify-content-center">
                                                                            <span
                                                                                style={{ cursor: "pointer", fontSize: 24, color: "red", fontWeight: "bold", lineHeight: 1 }}
                                                                                onClick={() => removeChild(index)}
                                                                                title="Remove"
                                                                            >
                                                                                –
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            ))}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Tab>

                                            {/* ---------------- BANK ---------------- */}
                                            <Tab eventKey="bank" title="Bank Details">
                                                <div ref={bankRef} className="tabBodyScroll--tall" style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}>
                                                    <Row>
                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Account Number<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        id="account_number"
                                                                        required
                                                                        value={form.account_number}
                                                                        placeholder="Enter A/C Number"
                                                                        onChange={digitsOnly("account_number")}
                                                                        maxLength={20}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        IFSC Code<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control id="ifsc_code" value={form.ifsc_code} placeholder="e.g., SBIN0001234" onChange={handleIFSC} maxLength={11} required />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Account Holder Name<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control required id="account_name" value={form.account_name} onChange={handleInputChange} maxLength={50} placeholder="As per bank records" />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Bank Name<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control required id="bank_name" value={form.bank_name} onChange={handleInputChange} maxLength={50} placeholder="Enter Bank name" />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Branch Name<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control required id="branch_name" value={form.branch_name} onChange={handleInputChange} maxLength={50} placeholder="Enter Branch Name" />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                                            <div className="commonInput">
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        Location<span className="requiredStar">*</span>
                                                                    </Form.Label>
                                                                    <Form.Control id="location" value={form.location} onChange={handleInputChange} maxLength={250} placeholder="City / Area" />
                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Tab>

                                            {/* ---------------- SALARY ---------------- */}
                                            <Tab eventKey="salary" title="Salary">
                                                <div ref={salaryRef} className="tabBodyScroll">
                                                    <input type="hidden" value={form.employee_salary_id || ""} readOnly />

                                                    <Row className="g-2">
                                                        <Col>
                                                            <Card className="h-100 shadow-sm">
                                                                <Card.Header className="py-2">Salary Settings</Card.Header>
                                                                <Card.Body className="p-2">
                                                                    <Row className="align-items-stretch">
                                                                        {/* LEFT SIDE: Period & Status */}
                                                                        <Col xs={6} style={{ borderRight: "1px solid #dee2e6" }}>
                                                                            <Row className="g-2">
                                                                                <Col xs={4}>
                                                                                    <div className="commonInput">
                                                                                        <Form.Group className="mb-1">
                                                                                            <Form.Label className="mb-1 small">
                                                                                                Effective From <span className="requiredStar">*</span>
                                                                                            </Form.Label>
                                                                                            <Form.Control
                                                                                                size="sm"
                                                                                                type="date"
                                                                                                id="effective_from"
                                                                                                required
                                                                                                value={form.effective_from || ""}
                                                                                                onChange={(e) =>
                                                                                                    setForm((p) => ({ ...p, effective_from: e.target.value }))
                                                                                                }
                                                                                            />
                                                                                        </Form.Group>
                                                                                    </div>
                                                                                </Col>

                                                                                <Col xs={4}>
                                                                                    <div className="commonInput ms-4">
                                                                                        <Form.Group className="mb-1">
                                                                                            <Form.Label className="mb-1 small">Effective To</Form.Label>
                                                                                            <Form.Control
                                                                                                size="sm"
                                                                                                type="date"
                                                                                                id="effective_to"
                                                                                                value={form.effective_to || ""}
                                                                                                min={form.effective_from || ""}
                                                                                                onChange={(e) =>
                                                                                                    setForm((p) => ({ ...p, effective_to: e.target.value }))
                                                                                                }

                                                                                            />
                                                                                        </Form.Group>
                                                                                    </div>
                                                                                </Col>

                                                                                <Col xs={4}>
                                                                                    <div className="commonInput">
                                                                                        <Form.Group className="mb-1">
                                                                                            <Form.Label className="mb-1 small d-block ms-4">
                                                                                                Is Current <span className="requiredStar">*</span>
                                                                                            </Form.Label>
                                                                                            <div className="d-flex align-items-center gap-5 ms-4">
                                                                                                <Form.Check
                                                                                                    inline
                                                                                                    type="radio"
                                                                                                    className="small"
                                                                                                    label="Yes"
                                                                                                    name="is_current"
                                                                                                    id="is_current_y"
                                                                                                    checked={form.is_current === "Y"}
                                                                                                    onChange={() =>
                                                                                                        setForm((p) => ({ ...p, is_current: "Y", effective_to: "" }))
                                                                                                    }
                                                                                                    required
                                                                                                />
                                                                                                <Form.Check
                                                                                                    inline
                                                                                                    type="radio"
                                                                                                    className="small"
                                                                                                    label="No"
                                                                                                    name="is_current"
                                                                                                    id="is_current_n"
                                                                                                    checked={form.is_current === "N"}
                                                                                                    onChange={() =>
                                                                                                        setForm((p) => ({ ...p, is_current: "N" }))
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        </Form.Group>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>


                                                                        <Col xs={6}>
                                                                            <Row className="g-2">
                                                                                <Col xs={4}>
                                                                                    <div className="commonInput">
                                                                                        <Form.Group className="mb-1">
                                                                                            <Form.Label className="mb-1 small">CTC (auto)</Form.Label>
                                                                                            <InputGroup size="sm">
                                                                                                <InputGroup.Text className="px-2">₹</InputGroup.Text>
                                                                                                <Form.Control readOnly value={form.ctc || ""} />
                                                                                            </InputGroup>
                                                                                        </Form.Group>
                                                                                    </div>
                                                                                </Col>

                                                                                <Col xs={4}>
                                                                                    <div className="commonInput">
                                                                                        <Form.Group className="mb-1">
                                                                                            <Form.Label className="mb-1 small">Gross (auto)</Form.Label>
                                                                                            <InputGroup size="sm">
                                                                                                <InputGroup.Text className="px-2">₹</InputGroup.Text>
                                                                                                <Form.Control readOnly value={form.gross_salary || ""} />
                                                                                            </InputGroup>
                                                                                        </Form.Group>
                                                                                    </div>
                                                                                </Col>

                                                                                <Col xs={4}>
                                                                                    <div className="commonInput">
                                                                                        <Form.Group className="mb-1">
                                                                                            <Form.Label className="mb-1 small">Net (auto)</Form.Label>
                                                                                            <InputGroup size="sm">
                                                                                                <InputGroup.Text className="px-2">₹</InputGroup.Text>
                                                                                                <Form.Control readOnly value={form.net_salary || ""} />
                                                                                            </InputGroup>
                                                                                        </Form.Group>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </Card.Body>
                                                            </Card>
                                                        </Col>


                                                    </Row>
                                                    <Row>
                                                        <Col xs={3} >
                                                            <div className="commonInput">
                                                                <Form.Group className="mb-1">
                                                                    <Form.Label className="mb-1 small">Component</Form.Label>
                                                                    <Form.Select
                                                                        size="sm"
                                                                        value={selectedSalaryComp.component_id}
                                                                        onChange={(e) => setSelectedSalaryComp((s) => ({ ...s, component_id: e.target.value }))}
                                                                        disabled={!!editingCompId}                  // ⬅️ lock while editing
                                                                    >
                                                                        <option value="">Select Component</option>
                                                                        {(salaryComponents || []).map((c) => {
                                                                            const id = c.salary_component_id ?? c.component_id ?? c.id;
                                                                            const name = c.component_name ?? c.salary_component_name ?? c.name ?? c.component_code ?? "Component";
                                                                            const type = String(c.component_type_name || "").toUpperCase();
                                                                            return (
                                                                                <option key={id} value={id}>
                                                                                    {name}{type ? ` (${type})` : ""}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </Form.Select>

                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                        <Col xs={3} >
                                                            <div className="commonInput">
                                                                <Form.Group className="mb-1">
                                                                    <Form.Label className="mb-1 small">Amount</Form.Label>
                                                                    <InputGroup size="sm">
                                                                        <Form.Control
                                                                            inputMode="decimal"
                                                                            step="0.01"
                                                                            placeholder="e.g., 25000"
                                                                            value={selectedSalaryComp.amount}
                                                                            onChange={(e) => setSelectedSalaryComp((s) => ({ ...s, amount: e.target.value }))}
                                                                        />
                                                                        {editingCompId ? (
                                                                            <>
                                                                                <Button size="sm" variant="primary" onClick={addOrUpdateSalaryComp} title="Update">
                                                                                    Update
                                                                                </Button>
                                                                                <Button size="sm" variant="outline-secondary" onClick={cancelEditComp} title="Cancel">
                                                                                    <MdClose />
                                                                                </Button>
                                                                            </>
                                                                        ) : (
                                                                            <Button size="sm" variant="success" onClick={addOrUpdateSalaryComp} title="Add">
                                                                                <MdAdd />
                                                                            </Button>
                                                                        )}
                                                                    </InputGroup>

                                                                </Form.Group>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row className="g-1 mt-2">
                                                        <Col xs={12}>
                                                            <Card className="shadow-sm">
                                                                <Card.Header className="py-1 small">Selected Components</Card.Header>
                                                                {(() => {
                                                                    const all = salaryBreakup || [];
                                                                    const E = all.filter(it => typeFor(it) === "EARNING");
                                                                    const D = all.filter(it => typeFor(it) === "DEDUCTION");
                                                                    const rows = Math.max(E.length, D.length);

                                                                    if (rows === 0) return <div className="p-2 text-muted small">No components added.</div>;

                                                                    const tableS = { width: "100%", borderCollapse: "collapse" };
                                                                    const thS = { padding: "0.25rem 0.4rem", fontSize: "0.8rem", lineHeight: 1.1, border: 0 };
                                                                    const thGroup = {
                                                                        ...thS,
                                                                        background: "#0d6efd",
                                                                        color: "#fff",
                                                                        fontWeight: 600,
                                                                        textAlign: "center",
                                                                        borderRadius: 4
                                                                    };
                                                                    const tdS = { padding: "0.25rem 0.4rem", fontSize: "0.8rem", lineHeight: 1.1, border: 0 };
                                                                    const actS = { width: 64, minWidth: 64, whiteSpace: "nowrap" };
                                                                    const sep = { borderLeft: "1px solid var(--bs-border-color, #dee2e6)" };

                                                                    const renderCells = (item, sideIdx /* 0=Earnings, 1=Deductions */) => {
                                                                        const leftCellStyle = { ...tdS, ...(sideIdx > 0 ? sep : {}) };

                                                                        if (!item) {
                                                                            return (
                                                                                <>
                                                                                    <td style={leftCellStyle}></td>
                                                                                    <td className="text-end" style={tdS}></td>
                                                                                    <td className="text-end" style={{ ...tdS, ...actS }}></td>
                                                                                </>
                                                                            );
                                                                        }

                                                                        const m = compIndex[Number(item.salary_component_id)] || {};
                                                                        const label = m.name || item.component_name || "Component";

                                                                        const isLocalDelete = !form.employee_salary_id || !item.employee_salary_component_id;
                                                                        const isDeletingThis =
                                                                            !isLocalDelete && deletingCompId === item.employee_salary_component_id;

                                                                        return (
                                                                            <>
                                                                                <td style={leftCellStyle}>{label}</td>
                                                                                <td className="text-end" style={tdS}>{fmtAmt(item.amount)}</td>
                                                                                <td style={{ ...tdS, ...actS }}>
                                                                                    <span className="d-inline-flex align-items-center gap-1 float-end">
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="link"
                                                                                            className="p-0"
                                                                                            onClick={() => startEditComp(item)}
                                                                                            title="Edit"
                                                                                        >
                                                                                            <MdEdit />
                                                                                        </Button>
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="link"
                                                                                            className="p-0 text-danger"
                                                                                            onClick={() => removeSalaryComp(item.salary_component_id)}
                                                                                            title="Remove"
                                                                                            disabled={isDeletingThis}
                                                                                        >
                                                                                            {isDeletingThis ? <Spinner animation="border" size="sm" /> : <MdDelete />}
                                                                                        </Button>
                                                                                    </span>
                                                                                </td>
                                                                            </>
                                                                        );
                                                                    };

                                                                    return (
                                                                        <div className="table-responsive">
                                                                            <table style={tableS} className="mb-0">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th colSpan={3} style={thGroup}>Earnings</th>
                                                                                        <th colSpan={3} style={{ ...thGroup, ...sep }}>Deductions</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th style={thS}>Component</th>
                                                                                        <th className="text-end" style={thS}>Amount</th>
                                                                                        <th style={{ ...thS, ...actS }}></th>

                                                                                        <th style={{ ...thS, ...sep }}>Component</th>
                                                                                        <th className="text-end" style={thS}>Amount</th>
                                                                                        <th style={{ ...thS, ...actS }}></th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    {Array.from({ length: rows }).map((_, i) => (
                                                                                        <tr key={i}>
                                                                                            {renderCells(E[i], 0)}
                                                                                            {renderCells(D[i], 1)}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    );
                                                                })()}

                                                            </Card>
                                                        </Col>
                                                    </Row>

                                                </div>
                                            </Tab>
                                        </Tabs>

                                        <div
                                            className="tab-nav-actions d-flex gap-2 position-absolute end-0 top-0 me-2 z-3"
                                            style={{ marginTop: "-0.75rem" }}
                                        >
                                            <Button
                                                type="button"
                                                variant="outline-danger"
                                                onClick={() => window.history.back()}
                                            >
                                                Cancel
                                            </Button>
                                            {!isFirst && (
                                                <Button type="button" variant="outline-secondary" onClick={goPrev}>
                                                    Previous
                                                </Button>
                                            )}



                                            {!isLast && (
                                                <Button type="button" variant="outline-primary" onClick={goNextValidated}>
                                                    Next
                                                </Button>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-end mt-3">
                                {isLast && (
                                    <>
                                        <Button type="button" className="btn btn-info clearBtn " onClick={resetForm} style={{ marginRight: "10px" }}>
                                            Reset
                                        </Button>
                                        <Button type="button" className="btn btn-danger secondaryBtn" onClick={() => window.history.back()}>
                                            Cancel
                                        </Button>
                                        <Button type="submit" className="btn btn-success primaryBtn" disabled={!canSubmit}>
                                            Submit
                                        </Button>
                                    </>
                                )}
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default EmployeeAdd;